"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var lodash_1 = require("lodash");
var Objects_1 = require("../../api/Objects");
var ModelConstants_1 = require("../../constants/ModelConstants");
var EngineeringModel_1 = require("../../api/enggModel/EngineeringModel");
var SceCompressedModel_1 = require("../../models/SceCompressedModel/SceCompressedModel");
var ExportService = /** @class */ (function () {
    function ExportService() {
        this._objectsApi = new Objects_1.Objects();
        this._enggModelApi = new EngineeringModel_1.EngineeringModel();
    }
    ExportService.prototype.getUniqueModelsWithReferencedTypes = function (models) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var allModels, referencedTypesPromises, referencedTypesSet, uniqueModels;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        allModels = [];
                        referencedTypesPromises = lodash_1.map(models, function (model) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var referencedTypes;
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, this.getReferencedTypes(model)];
                                    case 1:
                                        referencedTypes = _a.sent();
                                        return [2 /*return*/, referencedTypes];
                                }
                            });
                        }); });
                        return [4 /*yield*/, Promise.all(referencedTypesPromises)];
                    case 1:
                        referencedTypesSet = _a.sent();
                        allModels = allModels.concat(models);
                        lodash_1.map(referencedTypesSet, function (referencedTypeSet) {
                            allModels = allModels.concat(referencedTypeSet);
                        });
                        uniqueModels = this.filterUniqueModels(allModels);
                        return [2 /*return*/, uniqueModels];
                }
            });
        });
    };
    ExportService.prototype.getReferencedTypes = function (model) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var modelsInfo, scePromises, sceModels;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (model.properties.types === undefined || lodash_1.isEmpty(model.properties.types)) {
                            return [2 /*return*/, []];
                        }
                        modelsInfo = [];
                        lodash_1.map(Object.keys(model.properties.types), function (typeGuid) {
                            var referencedBaseType = model.properties.types[typeGuid];
                            var parentType = {
                                modelId: referencedBaseType.objectTypeModel.value,
                                typeId: referencedBaseType.objectType.value,
                                version: referencedBaseType.version.value,
                                objectId: referencedBaseType.objectId.value
                            };
                            modelsInfo.push(parentType);
                            lodash_1.map(referencedBaseType.referencedTypes.value, function (referencedType) {
                                var matchedBuild = lodash_1.findIndex(modelsInfo, function (x) {
                                    return referencedType.modelId === x.modelId &&
                                        referencedType.typeId === x.typeId &&
                                        referencedType.version == x.version &&
                                        referencedType.objectId == x.objectId;
                                });
                                if (matchedBuild === -1) {
                                    modelsInfo.push(referencedType);
                                }
                            });
                        });
                        scePromises = lodash_1.map(modelsInfo, function (modelInfo) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var response, enggModelResult, _a, queryResult, compressedModel, uncompressedModel;
                            return tslib_1.__generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        _b.trys.push([0, 2, , 4]);
                                        return [4 /*yield*/, this._enggModelApi.GetEnggModel(modelInfo.objectId, ModelConstants_1.ModelConstants.SceModel)];
                                    case 1:
                                        enggModelResult = _b.sent();
                                        response = enggModelResult.data;
                                        return [3 /*break*/, 4];
                                    case 2:
                                        _a = _b.sent();
                                        return [4 /*yield*/, this._objectsApi.queryForCompressedModelWithAssetMonitorAndVersion(ModelConstants_1.ModelConstants.SceModel, modelInfo.modelId, modelInfo.typeId, modelInfo.version)];
                                    case 3:
                                        queryResult = _b.sent();
                                        response = queryResult.data.data[0];
                                        return [3 /*break*/, 4];
                                    case 4:
                                        compressedModel = SceCompressedModel_1.SceCompressedModel.fromJson(response, false);
                                        uncompressedModel = compressedModel.properties.getUncompressedModel(modelInfo.modelId);
                                        return [2 /*return*/, uncompressedModel];
                                }
                            });
                        }); });
                        return [4 /*yield*/, Promise.all(scePromises)];
                    case 1:
                        sceModels = _a.sent();
                        return [2 /*return*/, sceModels];
                }
            });
        });
    };
    ExportService.prototype.filterUniqueModels = function (models) {
        var uniqueModels = [];
        lodash_1.map(models, function (model) {
            var matchedModel = lodash_1.findIndex(uniqueModels, function (uniqueModel) {
                var modelForCompare = uniqueModel.properties.model;
                var modelToCompare = model.properties.model;
                return (modelForCompare.model.value === modelToCompare.model.value) &&
                    (modelForCompare.typeId.value === modelToCompare.typeId.value) &&
                    (modelForCompare.version.value === modelToCompare.version.value);
            });
            if (matchedModel === -1) {
                uniqueModels.push(model);
            }
        });
        return uniqueModels;
    };
    return ExportService;
}());
exports.ExportService = ExportService;
//# sourceMappingURL=ExportService.js.map